/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { shortenStringWithTooltip } from '../../helper';
import ModalContext from '../../DamPreviewModal/ModalContext';
import DamPreviewModal from '../../DamPreviewModal';
import noImage from '../../../assets/images/no-image.png';
import imageIcon from '../../../assets/images/Image_Icon.svg';
import videoIcon from '../../../assets/images/Video_Icon.svg';
import ImageLazyLoader from '../../ImageLazyLoader';

function DamListCard({
  item,
  index,
  onCheck,
  onDelete,
  selectedIds,
  handleArchive,
  onAddAssetModal,
  isFolderArchived,
  disabledTillSameUplaoderUpdatedTheSameRecords,
  damAddEditAccess,
  damDeleteAccess,
  isFileProductLevel,
  isFolderProductLevel,
  folderId,
  onAddAssetToLibraryModal,
  onUnlink,
  folderIndex,
  handleFileCheckboxChange,
  isProductArchived,
}) {
  const { devOrderId } = useParams();
  const isChecked = selectedIds?.filter((val) => val === item?._id).length > 0;
  const { isModalOpen, openModal, setDamFileid, closeModal, setModalData, setDamDevOrderId } = useContext(ModalContext);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation('common');
  const isUplaoderDisabled = disabledTillSameUplaoderUpdatedTheSameRecords?.includes(item?._id);
  const activeState = location?.state?.activeList ? location?.state?.activeList : 'open';

  const getFullName = (obj) => {
    if (obj?.firstName && obj?.lastName) {
      return `${obj?.firstName} ${obj?.lastName}`;
    }
    return obj?.name;
  };

  useEffect(() => {
    return () => {
      closeModal(false);
      setModalData(null);
    };
  }, []);

  const isImageType = ['image', 'imageLink'].includes(item?.assetType);
  const isVideoType = ['video', 'videoLink'].includes(item?.assetType);

  const onEditClick = () => {
    if (devOrderId) {
      history.push(`/digital-assets-management/${devOrderId}/edit/${item?._id}`);
    } else {
      history.push(`/digital-assets-management/edit/${item?._id}`);
    }
  };

  return (
    <>
      <div id="accordion" className="col-md-3 mb-3 dam-card-container">
        <Card className="listing-card mb-0">
          <Card.Header>
            <div className="d-flex align-items-center min-h-40">
              {!isFolderArchived && !isFolderProductLevel && (
                <ul className="card-header-icon">
                  {activeState !== 'bin' && (damAddEditAccess || damDeleteAccess) && (
                    <li>
                      <div className="cus-chk-block">
                        <input
                          onChange={(e) => {
                            onCheck(e, item._id, index);
                          }}
                          name={`check_${index}`}
                          id={`check_${index}`}
                          type="checkbox"
                          checked={isChecked}
                          disabled={isUplaoderDisabled || isProductArchived}
                        />
                        <label htmlFor={`check_${index}`} className="cus-chklabel" />
                      </div>
                    </li>
                  )}
                  {(activeState === 'open' || isFileProductLevel) && damAddEditAccess && (
                    <li>
                      <button
                        disabled={isUplaoderDisabled || isProductArchived}
                        type="submit"
                        aria-label="Edit"
                        title="Edit"
                        className="btn p-0"
                        onClick={onEditClick}
                      >
                        <i className="icon-edit" />
                      </button>
                    </li>
                  )}
                  {isFileProductLevel && damAddEditAccess && (
                    <li>
                      <button
                        type="button"
                        onClick={() => {
                          onAddAssetToLibraryModal(item?._id);
                        }}
                        className="btn p-0"
                        aria-label="Delete"
                        title="Add to library"
                        disabled={isProductArchived}
                      >
                        <i className="icon-add_to_library" />
                      </button>
                    </li>
                  )}
                  {activeState !== 'bin' && !isFileProductLevel && !isFolderProductLevel && damAddEditAccess && (
                    <li>
                      <a
                        href={false}
                        onClick={() => handleArchive(item?._id)}
                        title={!item?.isArchived ? 'Archive' : 'Unarchive'}
                        aria-label={!item?.isArchived ? 'Archive' : 'Unarchive'}
                        disabled={isUplaoderDisabled}
                      >
                        <i className="icon-server" />
                      </a>
                    </li>
                  )}
                  {activeState === 'open' && !isFileProductLevel && damAddEditAccess && (
                    <li>
                      <button
                        type="submit"
                        className="btn p-0"
                        onClick={() => history.push(`/digital-assets-management/duplicate/${item?._id}`, { isDuplicate: true })}
                        title={t('DAM_MAIN_VIEW.LISTING_VIEW.DUPLICATE_DAM_FILE')}
                        aria-label={t('DAM_MAIN_VIEW.LISTING_VIEW.DUPLICATE_DAM_FILE')}
                        disabled={isUplaoderDisabled || isProductArchived}
                      >
                        <i className="icon-duplicate" />
                      </button>
                    </li>
                  )}
                  {activeState === 'open' && !isFileProductLevel && damAddEditAccess && (
                    <li>
                      <a
                        href={() => false}
                        title={t('DAM_MAIN_VIEW.LISTING_VIEW.ASSET_FOLDER')}
                        onClick={() => {
                          onAddAssetModal(item._id);
                        }}
                        aria-label="Assets"
                        disabled={isUplaoderDisabled || isProductArchived}
                      >
                        <i className="icon-add_to_colour_group" />
                      </a>
                    </li>
                  )}

                  {((item?.isArchived || isFileProductLevel) && damDeleteAccess) ||
                    (isProductArchived && (
                      <li>
                        <a
                          href={() => false}
                          title="Delete"
                          onClick={() => {
                            onDelete(item._id);
                          }}
                          aria-label="Delete"
                          disabled={isUplaoderDisabled}
                        >
                          <i className="icon-delete" />
                        </a>
                      </li>
                    ))}
                </ul>
              )}
              {isFolderProductLevel && (
                <ul className="card-header-icon">
                  <li>
                    <div className="cus-chk-block">
                      <input
                        onChange={() => handleFileCheckboxChange(folderIndex, item?._id)}
                        name={`check_${folderIndex}_${item?._id}`}
                        id={`check_${folderIndex}_${item?._id}`}
                        type="checkbox"
                        checked={item?.selected}
                        disabled={isProductArchived}
                      />
                      <label htmlFor={`check_${folderIndex}_${item?._id}`} className="cus-chklabel" />
                    </div>
                  </li>
                </ul>
              )}
              {isFolderProductLevel && damDeleteAccess && (
                <ul className="card-header-icon">
                  <li>
                    <button
                      type="submit"
                      className="btn p-0"
                      aria-label="Delete"
                      title="Unlink"
                      onClick={() => onUnlink(item?._id, folderId)}
                      disabled={isProductArchived}
                    >
                      <i className="icon-new-unlink f-14" />
                    </button>
                  </li>
                </ul>
              )}
              <div className="info-container xs-position-bottom iconfirst testing-action-spaceremoval placement-top">
                <span className="icon-info" />
                <div className="info-content">
                  <p className="text-left m-0">
                    <strong>{t('CUSTOM_MODULE.CREATED')} </strong> : {`${typeof item?.createdBy === 'object' ? getFullName(item?.createdBy) : item?.createdBy}`}{' '}
                    {item?.createdAt && moment(item?.createdAt).format('DD-MMMM-YYYY, HH:mm')}
                  </p>

                  <p className="text-left m-0">
                    <strong>{t('CUSTOM_MODULE.MODIFIED')} </strong> :{' '}
                    {`${typeof item?.modifiedBy === 'object' ? getFullName(item?.modifiedBy) : item?.modifiedBy}`}{' '}
                    {item?.updatedAt && moment(item?.updatedAt).format('DD-MMMM-YYYY, HH:mm')}
                  </p>
                  {!isEmpty(item?.archivedComment) && (
                    <p className=" comment-box " style={{ margin: '2px' }}>
                      {item?.archivedComment}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </Card.Header>
          <Card.Body
            onClick={() => {
              openModal();
              setDamFileid(item?._id);
              if (devOrderId) {
                setDamDevOrderId(devOrderId);
              }
            }}
          >
            <div className="dam-img-container cursor-pointer">
              {(isImageType || isVideoType) && <img src={isImageType ? imageIcon : videoIcon} className="item-icon" alt="" />}
              <ImageLazyLoader height={200} src={item?.croppedImage || item?.imageUrl || item?.imageLink || item?.videoThumbnail || noImage} />
            </div>

            <p className="font-weight-bold py-2 mb-0">{item?.assetTitle ? shortenStringWithTooltip(item.assetTitle, 40) : ''}</p>
          </Card.Body>
        </Card>
      </div>
      {isModalOpen && <DamPreviewModal />}
    </>
  );
}

export default DamListCard;
